import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const AnimatedSection = ({ isReverse, imageSrc, children, onImageClick }) => {
  const [ref, inView] = useInView({ triggerOnce: false, threshold: 0.25 });

  const imageInitialX = isReverse ? 200 : -200;
  const paragraphInitialX = isReverse ? -200 : 200;

  const transition = { duration: 0.8, ease: "easeInOut" };

  return (
    <div
      ref={ref}
      className='section-wrapper section-container'
    >
      <motion.div
        className='section-image-wrapper'
        initial={{ opacity: 0, x: imageInitialX }}
        animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: imageInitialX }}
        transition={transition}
      >
        <img className='section-image' src={imageSrc} alt="" onClick={onImageClick} />
      </motion.div>

      <motion.div
        className='section-paragraph-wrapper'
        initial={{ opacity: 0, x: paragraphInitialX }}
        animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: paragraphInitialX }}
        transition={transition}
      >
        {children}
      </motion.div>
    </div>
  );
};

export default AnimatedSection;
